import { useCallback } from 'react';
import { useIntakeFormShallowStore } from '@frontend/api-intake-form';
import { useLocation, type NavigateOptions } from '@frontend/weave-router';
import { INTAKE_FORM_DEMO_PATHS } from '../constants';

export type GetFormPathFnType = (args: NavigateOptions) => NavigateOptions;

type UseIntakeFormPathsType = {
  isDemoRoute: boolean;
  getFormPath: GetFormPathFnType;
};

export const useIntakeFormPaths = (): UseIntakeFormPathsType => {
  const current = useLocation();
  const { selectedIntakeFormLocationId } = useIntakeFormShallowStore('selectedIntakeFormLocationId');

  const isDemoRoute = current.pathname.startsWith(INTAKE_FORM_DEMO_PATHS.root);

  const getFormPath: GetFormPathFnType = useCallback(
    (args) => {
      const to =
        args.to?.startsWith('/onboarding/form') && isDemoRoute
          ? args.to.replace('/onboarding/form', '/onboarding-demo/form')
          : args.to;
      const params = {
        locationId: selectedIntakeFormLocationId,
        ...(args.params && typeof args.params === 'object' ? args.params : {}),
      };
      return {
        ...args,
        to,
        params,
      } as NavigateOptions;
    },
    [isDemoRoute, selectedIntakeFormLocationId]
  );

  return {
    isDemoRoute,
    getFormPath,
  };
};
